const API_BASE_URL = process.env.API_BASE_URL || "/api";

export async function login(email: string, password: string): Promise<void> {
  const response = await fetch(`${API_BASE_URL}/login`, {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
    },
    credentials: "include",
    body: JSON.stringify({ email, password }),
  });

  if (!response.ok) {
    throw new Error("Failed to login");
  }
  return;
}

export async function logout(): Promise<void> {
  const response = await fetch(`${API_BASE_URL}/logout`, {
    method: "POST",
    credentials: "include",
  });

  if (!response.ok) {
    throw new Error("Failed to logout");
  }
  return;
}

export async function updatePassword(
  currentPassword: string,
  password: string,
): Promise<void> {
  const response = await fetch(`${API_BASE_URL}/user`, {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
    },
    credentials: "include",
    body: JSON.stringify({ currentPassword, password }),
  });

  if (!response.ok) {
    throw new Error("Failed to update password");
  }
  return;
}
